export const UPDATE_SERVICE_GRID = "UPDATE_SERVICE_GRID";
export const GET_SERVICE_GRID = "GET_SERVICE_GRID";
export const ADD_SERVICES = "ADD_SERVICES";
export const DELETE_SERVICES = "DELETE_SERVICES";
export const ADD_CHARGES = "ADD_CHARGES";
export const DELETE_CHARGES = "DELETE_CHARGES";
export const EDIT_CHARGES = "EDIT_CHARGES";
export const EDIT_SERVICES = "EDIT_SERVICES";

